import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/onboarding/useOnboardingQueryKeys.ts
var t = e("onboarding", { status: () => ["status"] });
//#endregion
export { t as onboardingQueryKeys };
